import React, { useRef } from 'react';

const MapDataInput = ({ headers, addressField, onTablePaste, onAddressFieldSelect, onFileUpload }) => {
    const fileInputRef = useRef(null);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file && file.type === 'text/csv') {
            onFileUpload(file);
        } else {
            alert('Please upload a CSV file');
        }
    };

    return (
        <div>
            {/* File Upload */}
            <div className="mb-4">
                <label className="block text-sm font-medium mb-2">
                    Upload CSV file:
                </label>
                <div className="flex items-center">
                    <input
                        type="file"
                        accept=".csv"
                        onChange={handleFileChange}
                        ref={fileInputRef}
                        className="hidden"
                    />
                    <button
                        onClick={() => fileInputRef.current.click()}
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                    >
                        Choose File
                    </button>
                    <span className="ml-3 text-sm text-gray-600">
                        {fileInputRef.current?.files?.[0]?.name || 'No file chosen'}
                    </span>
                </div>
            </div>

            {/* Table Input */}
            <div className="mb-4">
                <label className="block text-sm font-medium mb-2">
                    Or paste your table data here (CSV or tab-separated):
                </label>
                <div 
                    className="w-full h-32 border p-2 overflow-auto"
                    onPaste={onTablePaste}
                    contentEditable
                ></div>
            </div>

            {/* Field Selection */}
            {headers.length > 0 && (
                <div className="mb-4">
                    <label className="block text-sm font-medium mb-2">
                        Select the address field:
                    </label>
                    <select 
                        className="border rounded p-2"
                        onChange={(e) => onAddressFieldSelect(e.target.value)}
                        value={addressField}
                    >
                        <option value="">Select field...</option>
                        {headers.map((header, index) => (
                            <option key={index} value={header}>
                                {header}
                            </option>
                        ))}
                    </select>
                </div>
            )}
        </div>
    );
};

export default MapDataInput;
